import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const fullNameFirstNameViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map